import { createContext } from 'react';
import { ContextValue } from './playlistPageTypes';

export default createContext<ContextValue | null>(null);
